import { TranslationMessages } from 'ra-core';
import frenchMessages from 'ra-language-french';

const customFrenchMessages: TranslationMessages = {
    ...frenchMessages,
    global: {
        auth: {
            email: 'Email',
            sign_in: 'Entrer',
            delete_account: 'Envoyer',
            account_deletion: 'Supprimer le compte',
            password: 'Mot de Passe',
            sign_in_error: "Erreur d'Authentification Failed",
        },
    },
    pos: {
        search: 'Rechercher',
        configuration: 'Configuration',
        language: 'Langue',
        theme: {
            name: 'Theme',
            light: 'Clair',
            dark: 'Obscur',
        },
        dashboard: {
            subscriptions_today: {
                title: 'Nouveaux Clients',
                subtitle: "Aujourd'hui",
            },
            subscriptions_total: {
                title: 'Total Clients',
                subtitle: '',
            },
            courses_today: {
                title: 'Nouvelles Courses',
                subtitle: "Aujourd'hui",
            },
            courses_total: {
                title: 'Total courses',
                subtitle: '',
            },
            drivers_online: {
                title: 'Chaufeurs Connectés',
                subtitle: 'Actuellement',
            },
            welcome: {
                title: 'Bienvenue dans Boxroad',
                subtitle: 'Ceci est le back-office Boxroad..',
                aor_button: 'Site web de Boxroad',
                demo_button: 'Code source de cette démo',
            },
        },
        menu: {
            sales: 'Ventes',
            prducts: 'Produits',
            users: 'Utilisateurs',
            delivery: 'Livraisons',
        },
        actions: {
            concel: 'Annuler',
        },
    },
    resources: {
        users: {
            name: 'Client |||| Clients',
            fields: {
                name: 'Nom Prénom',
                email: 'Email',
                phone: 'Tél',
                civility: 'Genre',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                birthdate: 'date de Naissance',
                socialReason: 'Raison Sociale',
                created_at: "Date d'inscription",
                updated_at: 'Dernière mise à jour',
                account_enabled: 'Activé',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
                nb_courses: 'N de Commandes',
            },
            civilities: {
                monsieur: 'M',
                madame: 'Mme',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                quizzes: 'Quizzes',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
                documents: 'Documents',
                factures: 'Factures',
            },
            tabs: {
                general: 'Général',
                documents: 'Documents',
                factures: 'Factures',
            },
            messages: {
                documents_placeholder:
                    'La gestion des documents sera implémentée ici.',
                factures_placeholder:
                    'La gestion des factures sera implémentée ici.',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        drivers: {
            name: 'Chauffeur |||| Chauffeurs',
            fields: {
                name: 'Nom Prénom',
                email: 'Email',
                phone: 'Tél',
                civility: 'Genre',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pay',
                birthdate: 'date de Naissance',
                socialReason: 'Raison Sociale',
                created_at: "Date d'inscription",
                updated_at: 'Dernière mise à jour',
                account_enabled: 'Activé',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
                nb_courses: 'N de Commandes',
                capital: 'Capital',
            },
            civilities: {
                monsieur: 'M',
                madame: 'Mme',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                quizzes: 'Quizzes',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            tabs: {
                documents: {
                    title: 'Documents',
                    expires_at: 'Expire le',
                    no_document: "Aucune image n'est associée à ce document",
                    no_documents_available: 'Aucun document disponible',
                    actions: {
                        view: 'Voir',
                        download: 'Télécharger',
                    },
                    types: {
                        passport: 'Passeport',
                        cni_recto: 'CNI (Recto)',
                        cni_verso: 'CNI (Verso)',
                        rib: 'Autorisation de RIB',
                        kbis: 'KBIS',
                        assurance_flotte_vehicule: 'Assurance Flotte Véhicule',
                        attestation_assurance_resp_civile:
                            'Attestation Assurance Responsabilité Civile',
                        attestation_assurance_resp_contractuelle:
                            'Attestation Assurance Responsabilité Contractuelle',
                        attestation_vigilance_urssaf:
                            'Attestation Vigilance URSSAF',
                        attestation_travailleurs_etrangers:
                            'Attestation Travailleurs Étrangers',
                        licence_intracommunautaire:
                            'Licence Intracommunautaire',
                    },
                    document_type: {
                        passport: 'Passeport',
                        cni: 'CNI',
                    },
                },
            },
            page: {
                delete: 'Supprimer le Chauffeur',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        admins: {
            name: 'Administrateur |||| Administrateurs',
            fields: {
                name: {
                    first: 'Prénom',
                    last: 'Nom',
                },
                email: 'Email',
                phone: 'Tél',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                socialReason: 'Raison Sociale',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                account_enabled: 'Activé',
                commands: 'Commandes',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },
        operators: {
            name: 'Opérateur |||| Opérateurs',
            fields: {
                name: {
                    first: 'Nom',
                    last: 'Prénom',
                    full: 'Nom Complet',
                },
                email: 'Email',
                phone: 'Tél',
                address1: 'Adresse',
                city: 'Ville',
                country: 'Pays',
                socialReason: 'Raison Sociale',
                created_at: 'Crée le',
                updated_at: 'Dernière mise à jour',
                account_enabled: 'Activé',
                commands: 'Commandes',
                password: 'Mot de passe',
                confirm_password: 'Confirmez le mot de passe',
            },
            filters: {
                last_visited: 'Dernière visite',
                today: "Aujourd'hui",
                this_week: 'Cette semaine',
                last_week: 'La semaine dernière',
                this_month: 'Ce mois-ci',
                last_month: 'Le mois dernier',
                earlier: 'Plus tôt',
                has_ordered: 'A déjà commandé',
                has_newsletter: 'Abonné newsletter',
                group: 'Segment',
            },
            fieldGroups: {
                identity: 'Identité',
                phone: 'Tél',
                address: 'Adresse',
                pricing: 'Tarification',
                history: 'Historique',
                password: 'Mot de passe',
                change_password: 'Changer le mot de passe',
            },
            page: {
                delete: 'Supprimer le client',
            },
            errors: {
                password_mismatch:
                    'La confirmation du mot de passe est différent du mot de passe.',
            },
        },

        banners: {
            name: 'Bannière |||| Bannières',
            fields: {
                name: 'Nom',
                image: 'Image',
                target: 'Cible',
                targetModel: 'Type',
                category: 'Catégorie',
                feature: 'Feature',
            },
            image: {
                upload_several:
                    'Glissez des photos à uploader ou cliquez pour en sélectionner une.',
                upload_single:
                    'Glissez une photo à uploader ou cliquez pour la sélectionner.',
            },
        },
        courses: {
            name: 'Course |||| Courses',
            fields: {
                user: 'Client',
                code: 'Numéro',
                code_str: 'Numéro',
                the_client: 'Le nom de client',
                client_phone: 'Le numéro de phone de client',
                from: 'De',
                from_address1: "De l'adresse 1",
                from_address2: "De l'adresse 2",
                from_city: 'De la ville',
                from_country: 'De la conmpagne',
                from_name: 'Nom de l’entreprise ou du particulier',
                from_zipcode: 'Code postal',
                to: 'Vers',
                to_address: "Vers l'adresse",
                to_address1: "Vers l'adresse 1",
                to_address2: "Vers l'adresse 2",
                to_city: 'Vers la ville',
                to_country: 'Vers la conmpagne',
                to_name: 'Nom de l’entreprise ou du particulier',
                to_zipcode: 'Code postal',
                name_driver: 'Nom et Prénom de chauffeur',
                phone_driver: 'Téléphone de chauffeur',
                notified_drivers: 'Chauffeurs notifiés',
                google_distance: 'Distance Estimée Google',
                google_duration: 'Durée Estimée Google',
                real_distance: 'Distance Réelle',
                real_duration: 'Durée Réelle',
                statut: 'Statut',
                client_note: 'Note client',
                client_comment: 'Commentaire clent',
                payed_price: 'Prix',
                estimated_price: 'Prix Estimé',
                created_at: 'Date de Création',

                client: 'Nom du client',
                driver: 'Nom du transporteur',
                t: '-',
            },
            course_statut: {
                new: 'Nouvelle',
                in_search: 'En Recherche',
                driver_notified: 'En attente de Chauffeur',
                conceled_by_client: 'Abandonnée par Client',
                conceled_by_driver: 'Abandonnée par Chauffeur',
                accepted: 'Acceptée',
                in_place: 'Chauffeur sur place',
                started: 'Démarrée',
                finished: 'Terminée (Non encore payée)',
                payed: 'Payée',
                not_payed: 'Paiement échoué',
                conceled: 'Abandonnée par Client',
                engaged: 'Engagée',
                loaded: 'Chargée',
                shipped: 'Livrée',
                shipping_confirmed: 'Terminée :le client confirme la livraison',
                shipping_confirmed_auto:
                    'Terminée : livraison a été confirmée automatiquement',
                shipping_not_confirmed:
                    'Terminée : le client ne confirme pas la livraison',
            },
            actions: {
                pay: 'Payer',
            },
            tabs: {
                details: 'Détails',
                history: 'Historique',
            },
            history: {
                title: 'Historique de la commande',
                statuses: {
                    new: 'Nouvelle commande',
                    accepted: 'Acceptée',
                    canceled: 'Annulée',
                    conceled: 'Annulée',
                    engaged: 'Engagée',
                    started: 'Démarrée',
                    loaded: 'Chargée',
                    shipped: 'Expédiée',
                    shipping_confirmed: 'Livraison confirmée',
                    shipping_not_confirmed: 'Livraison non confirmée',
                    payed: 'Payée',
                    not_payed: 'Non payée',
                },
                labels: {
                    comment: 'Commentaire',
                    photo: 'Photo',
                    at: 'à',
                },
            },
        },

        reviews: {
            name: 'Avis |||| Avis',
            fields: {
                sender: 'Expéditeur',
                created_for: 'A créé pour',
                livreur: 'Livreur',
                course: 'Course',
                note: 'Note',
                comment: 'Commentaire',
                status: 'Statut',
                created_at: 'Date de Création',
                updated_at: 'Dernière mise à jour',
                t: '-',
            },
            status: {
                accepted: 'Accepté',
                rejected: 'Rejeté',
                pending: 'En attente',
            },
            actions: {
                reject: 'Rejeter',
                accept: 'Accepter',
            },
        },
        course_events: {
            name: 'Evenement |||| Evenements',
            fields: {
                source: 'Déclanché par',
                to_statut: 'Statut',
                created_at: 'Date de Création',
            },
            source_types: {
                user: 'Client',
                driver: 'Chauffeur',
                operator: 'Opérateur',
                admin: 'Administrateur',
            },
        },
        factures: {
            name: 'Facture |||| Factures',
            fields: {
                number: 'Numéro',
                date: 'Date',
                price: 'Prix',
                file: 'Fichier',
            },
            actions: {
                view: 'Voir',
                export: 'Exporter',
            },
            messages: {
                no_factures: 'Aucune facture trouvée pour ce client.',
            },
        },
        factures_boxroad: {
            name: 'Facture Boxroad |||| Factures Boxroad',
            fields: {
                number: 'Numéro',
                date: 'Date',
                price_ht: 'Montant HT',
                price_ttc: 'Montant TTC',
                tax: 'Montant TVA',
                file: 'Fichier',
                status: 'Statut',
                livreur: 'Livreur',
                course: 'Course',
                transaction_number: 'N° Transaction',
            },
            status: {
                paid: 'Payée',
                not_paid: 'Impayée',
            },
            actions: {
                view: 'Voir',
                export: 'Exporter',
            },
            messages: {
                no_factures: 'Aucune facture trouvée pour ce transporteur.',
            },
        },

        settings: {
            name: 'Paramètres |||| Paramètres',
            fields: {
                storeVersion: "Version de l'app",
                storeURL: "URL de l'app",
                forceUpgrade: 'Forcer une mise à jour',
                maintenanceMode: 'Activer le mode maintenance',
                created_at: 'Date de creation',
                updated_at: 'Dernière mise à jour',
            },
            apps: {
                appClient: 'Application Client',
                appLivreur: 'Application Livreur',
            },
            platforms: {
                ios: 'Plateforme iOS',
                android: 'Plateforme Android',
            },
        },
    },
};

export default customFrenchMessages;
